import React from 'react';
import useSharedGenrePageContext from '../common/hooks/useSharedGenrePageContext';
import useGenre from '../common/hooks/useGenre';
import useGenreShows from '../common/hooks/useGenreShows';
import GenreOptionComponent from '../common/components/GenreOptionComponent';
import GenreInfoDesktop from './GenreInfo';
import styles from './styles.module.scss';
import { size } from '@/helpers/lodash';
import { streamingContextTypes } from '@/config/events-keakie';
import ShowPreviewGrid from '@/components/app/ShowPreviewGrid';
import ErrorWidget from '@/components/app/Error/ErrorWidget';
import LayoutWrapperHorizontal from '@/components/component-library/LayoutWrapperHorizontal';
import LayoutWrapperVertical from '@/components/component-library/LayoutWrapperVertical';
import OptionSelectorHorizontal from '@/components/component-library/OptionSelectorHorizontal';
import Text, { FONT_SIZE_140 } from '@/components/component-library/Text';
import useInitialRender from '@/hooks/browser/useInitialRender';

const DROP_DOWN_SELECT_PROPS = {
  optionClassName: styles.dropDownSelectOption,
  OptionComponent: GenreOptionComponent
};

const GenrePageDesktop = () => {
  const { isFirstRender } = useInitialRender();
  const {
    selectedGenre,
    selectorOptions,
    onClickChannel
  } = useSharedGenrePageContext();
  const {
    genre,
    parentGenre,
    isLoading
  } = useGenre();
  const {
    shows: genreShows,
    refetch: handleRefetchGenreShows,
    isLoading: showsLoading,
    isFetching: showsFetching,
    isError: showsError
  } = useGenreShows();

  const { description, id: genreId } = genre;
  const { title: parentTitle } = parentGenre;
  const genreShowsCount = size(genreShows);

  return (
    <LayoutWrapperVertical className='dskt__genre-page' extraPagePadding>
      <Text
        bold
        loading={!parentTitle}
        size={FONT_SIZE_140}
        useHeaderFont
      >
        {parentTitle}
      </Text>
      <div className='dskt__genre-selector-wrapper'>
        <OptionSelectorHorizontal
          className='dskt__genre-selector'
          dropDownProps={DROP_DOWN_SELECT_PROPS}
          id='desktop-genre-selector'
          key={parentTitle}
          listClassName='dskt__genre-selector-list'
          loading={isLoading || isFirstRender || !selectorOptions.length}
          optionClassName='dskt__genre-selector-option'
          OptionComponent={GenreOptionComponent}
          options={selectorOptions}
          selectedId={selectedGenre.id}
        />
      </div>
      <div className='dskt__genre-separator' />
      <LayoutWrapperHorizontal className='dskt__genre-content'>
        <GenreInfoDesktop
          description={description}
          loading={!description}
          showsCount={genreShowsCount}
          showsCountLoading={showsLoading}
        />
        {!showsError && (showsLoading || !!genreShowsCount) && (
          <ShowPreviewGrid
            channels={genreShows}
            className='dskt__genre-shows-grid-wrapper'
            id={genreId}
            loading={showsLoading}
            onClickChannel={onClickChannel}
            streamingContext={streamingContextTypes.GENRE_SHOW_SLATE}
          />
        )}
        <ErrorWidget
          errorMessage='Failed to fetch shows.'
          onRetry={handleRefetchGenreShows}
          shouldDisplay={!showsFetching && showsError}
        />
      </LayoutWrapperHorizontal>
    </LayoutWrapperVertical>
  );
};

export default GenrePageDesktop;
